import React from 'react';
import { ArrowRight, Layers3 } from 'lucide-react';
import './CompareCoursesCTA.css';

const CompareCoursesCTA = () => {
  return (
    <section className="course-cta-section">
      <div className="course-cta-container">
        <div className="course-cta-content">
          <div className="course-cta-icon-box">
            <Layers3 className="course-cta-icon" />
          </div>
          <h2 className="course-cta-title">
            Not Sure Which Course Is Right For You?
          </h2>
          <p className="course-cta-subtitle">
            Compare our most popular programs and find the perfect path tailored to your career goals.
          </p>
          <a href="#compare-courses" className="course-cta-button">
            Compare Courses
            <ArrowRight className="course-cta-button-icon" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CompareCoursesCTA;
